<template>
    <div id="app">
        <router-view v-if="fetched"/>
        <div  v-else class="initial-loading">
            <i class="el-icon-loading"></i>
        </div>
    </div>
</template>

<script>
    import * as api from '@/api'
    import { mapActions } from 'vuex';
    var config = require('./config/config');
    export default {
        name: 'App',
        data() {
            return {
                fetched: false,
                accounts: {
                    username: config.username,
                    password: config.password
                }
            }
        },
        created(){
            api.getUser()
                .then(()=>{
                    console.log('Logged in');
                    let mode = window.localStorage.getItem('mode');
                    this.fetchDevices({mode: mode ? mode : 'box', searchValue: ''})
                    .then(() => {
                        this.fetched = true;
                    })
                })
                .catch(err=>{
                    console.log(err)
                        this.fetched = true;

                     if (this.$route.fullPath != '/login'){
                         this.$router.replace({ name: "Login" });
                     }
                })
        },
        mounted() {
            window.localStorage.removeItem('search-value');
            window.localStorage.removeItem('sort');
            /*if (this.$cookie.get("isLoggedIn")) {
                let mode = window.localStorage.getItem('mode');
                this.fetchDevices({mode: mode ? mode : 'box', searchValue: ''})
                    .then(() => {
                        this.fetched = true;
                    })
            } else {
                if (this.$route.fullPath != '/login') window.localStorage.setItem('fullPath', this.$route.fullPath);
                else window.localStorage.removeItem('fullPath');
                this.fetched = true;
                this.$router.replace({ name: "Login" });
            }*/
        },
        methods: {
            ...mapActions([
                'fetchDevices'
            ]),
            logout() {
                this.authenticated = false;
            }
        }
    }
</script>

<style src='xterm/css/xterm.css'>
    /* global styles */
</style>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    body{
        margin: 0;
    }
    .initial-loading {
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .initial-loading .el-icon-loading {
        font-size: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue